
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import FormLabel from '@/components/reusable-components/form/FormLabel.vue'
import { extend, ValidationProvider } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import FormError from '@/components/reusable-components/form/FormError.vue'
import { trans } from '@/plugins/Translator'
import TranslationModule from '@/utils/TranslationModule'

const BLOCK_SELECTOR = 'form-field'

// install all default rules from https://vee-validate.logaretm.com/v3/guide/rules.html#rules
Object.keys(rules).forEach((rule: string) => {
    extend(rule, {
        ...rules[rule],
        message: trans(`rule.${rule}`, TranslationModule.VALIDATION),
    })
})

@Component({
    inheritAttrs: false,
    components: { FormError, FormLabel, ValidationProvider },
})
export default class FormField extends Vue {
    @Prop({ type: String, default: 'text' }) type!: string
    @Prop({ type: String, required: true }) name!: string
    @Prop({ type: Boolean }) light!: boolean
    @Prop({ type: Boolean }) extralight!: boolean
    @Prop({ type: Boolean }) inputOnly!: boolean
    @Prop({ type: Boolean }) showEye!: boolean
    @Prop({ type: Boolean }) labelHidden!: boolean
    @Prop({ type: String }) rules!: string
    @Prop({ type: String }) validationMode!: string
    @Prop({ type: Number, default: 1 }) rows!: number
    @Prop({ type: String, default: null }) inputClass!: string
    @Prop({ type: String, default: null }) labelClass!: string
    @Prop({ type: Object, default: undefined }) validatorAttributes!: any
    @Prop({ type: Boolean }) disabled!: boolean
    @Prop() value!: unknown

    displayPlainPassword = false

    $refs!: {
        input: HTMLInputElement
        provider: any
    }

    get inputType() {
        let type = this.type

        if (type === 'password' && this.displayPlainPassword) {
            type = 'text'
        }

        return type
    }

    get required(): boolean {
        return !!(this.rules && this.rules.includes('required'))
    }

    get inputClassList() {
        const blockSelector = `${BLOCK_SELECTOR}__input`

        return [
            blockSelector,
            {
                [`${blockSelector}--light`]: this.light,
                [`${blockSelector}--extralight`]: this.extralight,
                [`${blockSelector}--input-only`]: this.inputOnly,
                [`${blockSelector}--with-icons`]: this.type === 'password',
                ['bg-white']: !this.disabled,
            },
            this.inputClass,
        ]
    }

    get labelClassList() {
        const blockSelector = `${BLOCK_SELECTOR}__label`

        return [blockSelector, this.labelClass]
    }

    get inputValue() {
        return this.value
    }

    set inputValue(value: unknown) {
        this.$emit('input', value)
    }

    focus() {
        this.$refs?.input.focus()
    }
}
